import { Route, Switch, useLocation } from "react-router-dom";

import { useIsUserLogged } from "modules/authentication/infrastructure/useIsUserLogged";
import { useUserActionWatcher } from "modules/authentication/infrastructure/useUserActionWatcher";

import { ErrorBoundary } from "components/ErrorBoundary/ErrorBoundary";

import { ProtectedRoutes } from "./ProtectedRoutes";
import { CommonRoutes } from "./CommonRoutes";

const Routes = () => {
  const { pathname } = useLocation();
  const isUserLogged = useIsUserLogged();
  useUserActionWatcher();

  return (
    <ErrorBoundary resetKeys={[pathname]}>
      <Switch>
        <Switch>
          {isUserLogged && (
            <Route
              path="/e-rezerwacja/:friendlyUrl/uzytkownik"
              component={ProtectedRoutes}
            />
          )}

          <Route path="/" component={CommonRoutes} />
        </Switch>
      </Switch>
    </ErrorBoundary>
  );
};

export { Routes };
